import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-213">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-214">
        <div className="flex items-center" data-id="element-215">
          <span className="text-indigo-600 text-2xl font-bold" data-id="element-216">
            Special Performances
          </span>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-217">
          <a href="#about" className="text-gray-600 hover:text-indigo-600 transition-colors" data-id="element-218">
            About
          </a>
          <a href="#features" className="text-gray-600 hover:text-indigo-600 transition-colors" data-id="element-219">
            Program
          </a>
          <a href="#faq" className="text-gray-600 hover:text-indigo-600 transition-colors" data-id="element-220">
            FAQ
          </a>
          <a href="#contact" className="text-gray-600 hover:text-indigo-600 transition-colors" data-id="element-221">
            Join Us
          </a>
        </nav>
        {/* Mobile menu button */}
        <button className="md:hidden text-gray-500 hover:text-indigo-600 focus:outline-none" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-222">
          {isMenuOpen ? <XIcon size={24} data-id="element-223" /> : <MenuIcon size={24} data-id="element-224" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white px-4 py-2 shadow-md" data-id="element-225">
          <div className="flex flex-col space-y-3 pb-3" data-id="element-226">
            <a href="#about" className="text-gray-600 hover:text-indigo-600 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-227">
              About
            </a>
            <a href="#features" className="text-gray-600 hover:text-indigo-600 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-228">
              Program
            </a>
            <a href="#faq" className="text-gray-600 hover:text-indigo-600 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-229">
              FAQ
            </a>
            <a href="#contact" className="text-gray-600 hover:text-indigo-600 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-230">
              Join Us
            </a>
          </div>
        </div>}
    </header>;
}